import { gql } from "@apollo/client";

export const GET_REALESTATE_USERS = gql`
    query GetRealestateUsers($realestateid: uuid!) {
        common_v_realestates_users(where: { realestateid: { _eq: $realestateid } }) {
            name
            name1
            name2
            email
            state
            lastlogin
            registeredat
            userinserted
            role
            login_audit: audits(order_by: { timestamp: desc }, where: { event: { _in: [10, 30] } }, limit: 1) {
                timestamp
                __typename
            }
            registered_audit: audits(order_by: { timestamp: desc }, where: { event: { _eq: 60 } }, limit: 1) {
                timestamp
                __typename
            }
            activated_audit: audits(order_by: { timestamp: desc }, where: { event: { _eq: 70 } }, limit: 1) {
                timestamp
                __typename
            }
            blocked_audit: audits(order_by: { timestamp: desc }, where: { event: { _eq: 90 } }, limit: 1) {
                timestamp
                __typename
            }
        }
    }
`;
